import React from "react";

import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import { dateFilter } from "@ip-utils";

import Between from "./Between";

export default function Date({
  clearable = true,
  compact,
  label = "Date",
  maxDate,
  name = "date",
  rows,
  onChange,
  ...props
}) {
  function handleChange(value) {
    onChange({
      target: {
        name,
        value,
      },
    });
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        autoOk
        clearable={clearable}
        disableFuture
        format="dd/MM/yyyy"
        label={label}
        maxDate={maxDate}
        name={name}
        onChange={onChange && handleChange}
        {...props}
      />
    </MuiPickersUtilsProvider>
  );
}

Date.Between = Between;

Between.filter = dateFilter;
